import React from 'react';
import styled from 'styled-components';

const StarsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
`;

const StarWrapper = styled.div`
  position: relative;
  font-size: 24px;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: transform 0.1s;
  
  &:hover {
    transform: ${props => props.clickable ? 'scale(1.2)' : 'none'};
  }
`;

const EmptyStar = styled.span`
  color: #d1d1d6;
`;

const FilledStar = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  color: #FF9500;
  overflow: hidden;
  width: ${props => props.percent}%;
`;

const RatingPrecision = styled.div`
  font-size: 12px;
  text-align: center;
  margin-left: 8px;
  color: #86868b;
  font-weight: bold;
`;

function StarRating({ 
  rating = 0, 
  maxRating = 5, 
  onRate, 
  readOnly = false,
  integerOnly = false
}) {
  const handleStarClick = (index, event) => {
    if (readOnly || !onRate) return;
    
    if (integerOnly) {
      onRate(index + 1);
    } else {
      const starRect = event.currentTarget.getBoundingClientRect();
      const starWidth = starRect.width;
      const clickX = event.clientX - starRect.left;
      const percentage = clickX / starWidth;
      const value = index + Math.round(percentage * 10) / 10;
      onRate(value);
    }
  };

  const renderStar = (index) => {
    let fillPercent;
    
    if (!readOnly && integerOnly) {
      fillPercent = index < Math.floor(rating) ? 100 : 0;
    } else {
      fillPercent = Math.max(0, Math.min(100, (rating - index) * 100));
    }
    
    return (
      <StarWrapper 
        key={index} 
        clickable={!readOnly}
        onClick={(e) => handleStarClick(index, e)}
      >
        <EmptyStar>★</EmptyStar>
        <FilledStar percent={fillPercent}>★</FilledStar>
      </StarWrapper>
    );
  };
  
  const preciseDecimal = rating % 1;
  const displayDecimal = preciseDecimal > 0 ? preciseDecimal.toFixed(1).substring(1) : '';

  return (
    <StarsContainer>
      {[...Array(maxRating)].map((_, i) => renderStar(i))}
      {preciseDecimal > 0 && (
        <RatingPrecision>
          {Math.floor(rating)}{displayDecimal}
        </RatingPrecision>
      )}
    </StarsContainer>
  );
}

export default StarRating; 